/* eslint-disable import/prefer-default-export */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

export const HOME_TAB = 'HOME_TAB';
export const MENU_TAB = 'MENU_TAB';
export const ACCOUNT_TAB = 'ACCOUNT_TAB';
export const CART_TAB = 'CART_TAB';
export const CHECKOUT_TAB = 'CHECKOUT_TAB';
